import { queryOptions } from '@tanstack/react-query'
import { companyRequest } from '@/shared/api'
import { CompanyListSchema, CompanyResponseSchema } from '../model/types'

export const companyKeys = {
  all: ['company'] as const,
  list: (q: string, archived: boolean) => ['company', 'list', q, archived] as const,
  detail: (id: string) => ['company', 'detail', id] as const,
}

export interface CompaniesFilter {
  q?: string
  archived?: boolean
}

export function companiesQueryOptions({ q = '', archived = false }: CompaniesFilter = {}) {
  return queryOptions({
    queryKey: companyKeys.list(q, archived),
    queryFn: async () => {
      // Wire: q + include_archived + page/size (huma-обёртка {data,total,page,size}).
      const body = await companyRequest<unknown>({
        method: 'GET',
        path: '/companies',
        query: { q, include_archived: archived, size: 200 },
      })
      return CompanyListSchema.parse(body).data ?? []
    },
  })
}

export function companyQueryOptions(id: string) {
  return queryOptions({
    queryKey: companyKeys.detail(id),
    queryFn: async () => {
      const body = await companyRequest<unknown>({ method: 'GET', path: `/companies/${id}` })
      return CompanyResponseSchema.parse(body).data
    },
  })
}
